module.exports = __webpack_public_path__ + "static/media/bufene61.a5ffa40f.png";